<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				身份认证
			</div>
		</div>
		<div class="form">
			<div class="form-item">
				<div class="title">
					<div>姓名</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.name" placeholder="请输入姓名">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>身份证号</div>
					<span>:</span>
				</div>
				<div class="inp" style="display: flex;">
					<input type="text" placeholder="请输入" v-model="serveData.id_card">
					<div v-if="this.serveData.wechat_data==1" @click="shiming()" style="width: 255px;
						color: #0052D9;
						text-align: center;
						line-height: 45px;
						line-height: 45px;
						border-radius: 5px;
						height: 45px;
						cursor: pointer;
						margin-left: 15px;
						background: #E5EDFB;
					">
						实名认证</div>
						<div v-if="this.serveData.wechat_data==2" style="width: 255px;
							color: #0052D9;
							text-align: center;
							line-height: 45px;
							line-height: 45px;
							border-radius: 5px;
							height: 45px;
							cursor: pointer;
							margin-left: 15px;
							background: #E5EDFB;
						">
							已完成实名认证</div>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>兴趣</div>
					<span>:</span>
				</div>
				<div class="inp">
					<!-- <input type="text" placeholder="检索您感兴趣的栏目"> -->
					<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
						<el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
					</el-checkbox-group>
					<input type="text" style="width: 150px;font-size: 16px;height: 30px;display: inline-block;"
					  @keyup.enter="huiche" v-model="addHob"  placeholder="其他,回车添加">
				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div>电子邮箱</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" v-model="serveData.email" placeholder="请输入邮箱账号">
						<div style="margin-left: 30px;display: flex;align-items: ;">
							<span style="line-height: 45px;">验证码:</span>
							<input type="text" style="width: 150px;margin-left: 10px;" v-model="serveData.email_code" placeholder="请输入验证码">
							<p class="getCode" @click="send" v-if="showtime===null">获取邮箱验证码</p>
							<p v-else class="getCode"> {{showtime}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>通讯地址</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" style="width: 893px;" v-model='serveData.address' placeholder="请输入通讯地址">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>个人主页</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" style="width: 893px;" v-model="serveData.home_page" placeholder="请输入个人主页地址">
				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title">
					<div>个人简介</div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-input id="textarea" type="textarea" placeholder="请输入个人信息简介"
						v-model="serveData.content" maxlength="140" resize='none' show-word-limit></el-input>
				</div>
			</div>
			<h3>学生认证(二选一)</h3>
			<div style="margin: 30px 0;">
				<el-upload class="upload-demo"
				 :on-remove='removeSchoolFile'
				 :on-success='uploadScool' :headers='{token:$store.state.userInfo.token}' :action="uploadPath+'common/upload'"   :limit="1"
					:file-list="fileList2">
					<div style="width: 340px;height: 48px;background: #EEEEEE;border: 1px solid #EEEEEE;
						line-height: 48px;text-align: center;
						 ">请上传相关认证</div>
				</el-upload>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div style="width: 113px;"> 学校邮箱认证</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" v-model="serveData.school_email" placeholder="请输入">
						<div style="margin-left: 30px;display: flex;align-items: ;">
							<span style="line-height: 45px;" >验证码:</span>
							<input type="text" style="width: 150px;margin-left: 10px;" v-model="serveData.school_email_code" placeholder="请输入验证码">
							<p class="getCode" @click="send2" v-if="showtime2===null">获取邮箱验证码</p>
							<p v-else class="getCode"> {{showtime2}}</p>
						</div>
					</div>
				</div>
			</div>
			<h3 style="margin-bottom: 30px;">单位认证</h3>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div style="width: 113px;"> 单位</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" v-model="serveData.company" placeholder="请输入单位名称">
						
					</div>
				</div>
			</div>
			<div style="margin: 30px 0;">
				<el-upload class="upload-demo"
				 :on-remove='removeCompanyFile'
				 :on-success='uploadCompanyFile'
				 :headers='{token:$store.state.userInfo.token}' :action="uploadPath+'common/upload'"  :limit="1"
					:file-list="fileList1">
					<div style="width: 340px;height: 48px;background: #EEEEEE;border: 1px solid #EEEEEE;
						line-height: 48px;text-align: center;
						 ">请上传相关认证</div>
				</el-upload>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div style="width: 113px;"> 单位邮箱认证</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" v-model="serveData.company_email" placeholder="请输入">
						<div style="margin-left: 30px;display: flex;align-items: ;">
							<span style="line-height: 45px;">验证码:</span>
							<input type="text" style="width: 150px;margin-left: 10px;" placeholder="请输入验证码"  v-model="serveData.company_email_code">
							<p class="getCode" @click="send3" v-if="showtime3===null">获取邮箱验证码</p>
							<p v-else class="getCode"> {{showtime3}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="commit" @click="saveAuthentication">提交认证</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				wechat_data:'',
				addHob:'',
				fileList1: [],
				fileList2: [],
				jianjie: '',
				cities: [],
				checkedCities: [],
				timeCounter: null,
				showtime: null,
				timeCounter2: null,
				showtime2: null,
				showtime3: null,
				DWtimeCounter: null,
				DWshowtime: null,
				schooltimeCounter: null,
				schoolshowtime: null,
				form2: {
					email: '',
					DWemail: '',
					schoolEmail: '',
				},
				serveData:{}
			}
		},
		created() {
			this.getIdAuthInfo()
		},
		methods: {
			async shiming(){
				const res = await this.$api.shiming({
					name:this.serveData.name,
					idnum:this.serveData.id_card,
					})
				console.log('实名结果',res);
				if(res.data.code==1){
					this.serveData.wechat_data = 2;
					this.$message({
						message:'实名认证成功！',
						type:'success'
					})
					this.serveData.interest_tags = this.checkedCities.join(',')
					const save = await this.$api.saveIdAuthentication({...this.serveData})
				}else{
					this.$message({
						message:'实名认证失败，请检查姓名与身份证号码是否正确！',
						type:'warning'
					})
				}
				
			},
			async saveAuthentication(){
				this.serveData.interest_tags = this.checkedCities.join(',')
				const save = await this.$api.saveIdAuthentication({...this.serveData})
				if(save.code == 1){
					this.$message({
						message:save.msg,
						type:'success'
					})
					// this.$router.
				}else{
					this.$message({
						message:save.msg,
						type:'warning'
					})
				}
			},
			removeCompanyFile(e,a){
				let path = a.map(item=> item.url)
				this.serveData.company_files = path.join(',')
			},
			removeSchoolFile(e,a){
				let path = a.map(item=> item.url)
				this.serveData.school_files = path.join(',')
			},
			uploadCompanyFile(flie,flieList){
				if(flie.code == 1){
					this.serveData.company_files = flie.data.url
				}
			},
			uploadScool(flie,flieList){
				if(flie.code == 1){
					this.serveData.school_files = flie.data.url
				}
			},
			async getIdAuthInfo(){
				const auth = await this.$api.IdAuthentication()
				if(auth.data.company_files_array){
					this.fileList1 = auth.data.company_files_array.map((item)=>{
						return {name:item.filename,url:item.url}
					})
				}
				if(auth.data.school_files_array){
					this.fileList2 = auth.data.school_files_array.map((item)=>{
						return {name:item.filename,url:item.url}
					})
				}
				if(auth.data.interest_tags){
					this.checkedCities = auth.data.interest_tags.split(',')
				}
				this.serveData = auth.data
				this.serveData.email_code = ''
				this.serveData.school_email_code = ''
				this.company_email_code = ''
				this.getTagList()
			},
			// 否
			// String
			// 邮箱验证码。邮箱有有变化了需要传
			// school_email_code
			// 否
			// String
			// 学校邮箱验证码。邮箱有有变化了需要传
			// company_email_code
			// 否
			// String
			// 公司邮箱验证码。邮箱有有变化了需要传
			async getTagList(){
				const tags = await this.$api.getInterestTagList({page_size:999})
				this.cities = tags.data.data.map(item=> item.name)
				this.checkedCities.forEach(city => {
				  if (!this.cities.includes(city)) {
				    this.cities.push(city);
				  }
				});
			},
			huiche(){
				if(this.addHob !== ''){
					if(this.cities.indexOf(this.addHob) == -1){
						this.cities.push(this.addHob)
						this.checkedCities.push(this.addHob)
						this.addHob = ''
					}
				}
			},
			parentMethod() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (this.form2.email == '') {
					this.$message.error('请填写邮箱');
					return false
					if (emailRegex.test(this.form2.email)) {
						return true
					} else {
						this.$message.error('邮箱格式错误');
						return false
					}
				}
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? cityOptions : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
			},
			countDownText3(s) {
				this.showtime3 = `${s}s后重新获取`
			},
			// 倒计时 60秒 不需要很精准
			countDown3(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter3 = setTimeout(countDownStart, interval);
			
				function countDownStart() {
					if (self.timeCounter3 == null) {
						return false;
					}
					count++
					self.countDownText3(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter3)
						self.showtime3 = null;
					} else {
						self.timeCounter3 = setTimeout(countDownStart, interval)
					}
				}
			},
			async send3() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (!emailRegex.test(this.serveData.company_email)) {
					this.$message({
						message: '邮箱号格式错误',
						type: 'warning'
					})
				} else {
					const yzcode = await this.$api.sendEmailCode({
						event: 'form',
						email: this.serveData.company_email
					})
					if(yzcode.code == 1){
						this.countDown3(60);
						this.$message({
							message:yzcode.msg,
							type:'success'
						})
					}else{
						this.$message({
							message:yzcode.msg,
							type:'warning'
						})
					}
				}
			},
			countDownText2(s) {
				this.showtime2 = `${s}s后重新获取`
			},
			// 倒计时 60秒 不需要很精准
			countDown2(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter2 = setTimeout(countDownStart, interval);
			
				function countDownStart() {
					if (self.timeCounter2 == null) {
						return false;
					}
					count++
					self.countDownText2(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter2)
						self.showtime2 = null;
					} else {
						self.timeCounter2 = setTimeout(countDownStart, interval)
					}
				}
			},
			async send2() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (!emailRegex.test(this.serveData.school_email)) {
					this.$message({
						message: '邮箱号格式错误',
						type: 'warning'
					})
				} else {
					const yzcode = await this.$api.sendEmailCode({
						event: 'form',
						email: this.serveData.school_email
					})
					if(yzcode.code == 1){
						this.countDown2(60);
						this.$message({
							message:yzcode.msg,
							type:'success'
						})
					}else{
						this.$message({
							message:yzcode.msg,
							type:'warning'
						})
					}
				}
			},
			countDownText(s) {
				this.showtime = `${s}s后重新获取`
			},
			// 倒计时 60秒 
			countDown(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter == null) {
						return false;
					}
					count++
					self.countDownText(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter)
						self.showtime = null;
					} else {
						self.timeCounter = setTimeout(countDownStart, interval)
					}
				}
			},
			async send() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (this.serveData.email == '') {
					this.$message.error('请填写邮箱');
					return
				}
				if (emailRegex.test(this.serveData.email)) {
					const yzcode = await this.$api.sendEmailCode({
						event: 'form',
						email: this.serveData.email
					})
					if(yzcode.code == 1){
						this.countDown(60);
						this.$message({
							message:yzcode.msg,
							type:'success'
						})
					}else{
						this.$message({
							message:yzcode.msg,
							type:'warning'
						})
					}
				} else {
					this.$message.error('邮箱格式错误');
				}
			},

		}
	}
</script>

<style lang="less" scoped>
	.getCode {
		width: 133px;
		height: 44px;
		border-radius: 5px;
		background: #0052D9;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	/deep/.el-checkbox {
		margin-bottom: 20px;
	}

	// /deep/.el-checkbox__inner::after {
	// 	height: 11px;
	// 	left: 6px;
	// 	top: 0;
	// }

	// /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
	// 	color: #0052D9;
	// }

	/deep/.el-checkbox__label {
		font-size: 16px;
	}

	// /deep/.el-checkbox__inner {
	// 	width: 18px;
	// 	height: 18px;
	// }

	// /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
	// 	background-color: #0052D9;
	// 	border-color: #0052D9;
	// }

	.commit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		color: white;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
		line-height: 40px;
		margin: auto;
		text-align: center;
	}

	/deep/.el-textarea__inner {
		width: 893px;
		height: 100px;
		font-size: 18px;
	}

	.form {
		padding: 40px 50px;
		box-sizing: border-box;

		/deep/.el-select {
			margin-bottom: 20px;
		}

		/deep/.el-textarea__inner {
			border: 1px solid #D2D2D2;
			color: black !important;
			font-family: none;
		}

		/deep/.el-input__inner {
			width: 448px;
			border: 1px solid #D2D2D2;
			line-height: 45px;
			font-size: 18px;
			color: black !important;
			height: 45px;
			box-sizing: border-box;
		}

		/deep/.el-textarea__inner::placeholder,
		/deep/.el-input__inner::placeholder {
			color: #999999;
			font-size: 18px;
		}

		.form-item {
			display: flex;
			margin-bottom: 30px;
			align-items: baseline;

			.inp {
				margin-left: 20px;

				& input {
					font-size: 18px;
					padding: 0 15px;
					box-sizing: border-box;
					width: 448px;
					height: 45px;
					border: 1px solid #D2D2D2;
					border-radius: 6px;
					margin-bottom: 20px;
				}
			}

			.title {
				font-size: 18px;
				display: flex;
				align-items: center;

				&>div {
					width: 113px;
					text-align-last: justify;
				}
			}
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>